<template >
<div class="parts d-flex justify-content-start">
  <grid-component 
    isResizable
    isReorderable
    :canEdit="checkClaim(CAN_EDIT_SOURCING_CENTER)"
    :canDelete="checkClaim(CAN_EDIT_SOURCING_CENTER)"
    :gridId="gridId"
    :itemData="parts"
    :fields="fields"
    :onDelete="onDelete"
    :disablesDelete="isRfpNotPending"
  />
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import fields from './fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  data: () => ({
    prepareColumnsData,
    fields,
    gridId: GRID_ID.RFP_DETAILS_SELECTED_PARTS
  }),
  props: {
    rfpHome: {
      default: false,
      type: Boolean,
    },
    isRfpNotPending: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('rfpDetails', ['partsById']),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('rfps', ['selectedRfpId']),
    gridSettings() {
      return this.gridSettingsById(GRID_ID.RFP_DETAILS_SELECTED_PARTS);
    },
     rfpId() {
      if(this.rfpHome) return this.selectedRfpId;

      return this.$route.params.id;
    },
    parts() {
      return this.partsById(this.rfpId);
    },
  },
  methods: {
    ...mapActions('rfpDetails', ['getParts', 'removePart']),
    ...mapActions('account', ['saveGridSettings']),
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({ id: GRID_ID.RFP_DETAILS_SELECTED_PARTS, settings: { columns: newColumns }});
    }, 500),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({ id: GRID_ID.RFP_DETAILS_SELECTED_PARTS, settings: { columns: newColumns }});
    },
    async onDelete(rfpPart) {
      if (!this.isRfpNotPending) {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete part "${rfpPart.partNumber}"?`});
        if (deleteConfirmed) {
          await this.removePart({
            rfpId: this.rfpId,
            rfpPartId: rfpPart.id,
          });

          this.$emit('remove-part');
        }
      }
    }
  },
  watch: {
    async selectedRfpId() {
      if (this.rfpId != null)
        await this.getParts(this.rfpId);
    }
  },
  mounted() {
    if(!this.rfpHome) this.getParts(this.rfpId);
  },
};
</script>

<style lang="scss" scoped>

.disabled-btn {
  color: #dddddd;
  cursor: no-drop;
}
.parts {
  overflow-y: auto;
   max-height: 345px;
  height: auto !important;
}

.row {
  margin-right: 0px !important;
}

</style>

